import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ROBOTS_META = "robots";

/** Paths under /app/ that should remain indexable (shared links for social previews). */
function isIndexableAppPath(pathname: string): boolean {
  return (
    pathname.startsWith("/app/shared-") ||
    pathname === "/app/course-shared" ||
    pathname === "/app/shared-tutorial" ||
    pathname === "/app/shared-playlist"
  );
}

function shouldNoIndex(pathname: string): boolean {
  if (!pathname.startsWith("/app/")) return false;
  return !isIndexableAppPath(pathname);
}

function setRobotsNoIndex(enabled: boolean) {
  let el = document.querySelector(`meta[name="${ROBOTS_META}"]`);
  if (enabled) {
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", ROBOTS_META);
      document.head.appendChild(el);
    }
    el.setAttribute("content", "noindex, nofollow");
    return;
  }
  el?.remove();
}

/**
 * Sets robots noindex on private app routes (dashboard, auth, tutorials, etc.)
 * while leaving public shared-link pages crawlable.
 */
export function AppSeoGuard() {
  const { pathname } = useLocation();

  useEffect(() => {
    setRobotsNoIndex(shouldNoIndex(pathname));
    return () => setRobotsNoIndex(false);
  }, [pathname]);

  return null;
}
